import {
    ResetButtonComponent as SourceResetButtonComponent,
} from 'SourceComponent/ResetButton/ResetButton.component';
import React from 'react';
import './ResetButton.override.style';
import { scrollToTop } from '@scandipwa/scandipwa/src/util/Browser';
import { removeQueryParamWithoutHistory } from '@scandipwa/scandipwa/src/util/Url';
import history from '@scandipwa/scandipwa/src/util/History';

export class ResetButtonComponent extends SourceResetButtonComponent {
    onClick() {
        const { onClick, resetFilters } = this.props;

        removeQueryParamWithoutHistory('customFilters', history, window.location);
        onClick();
        resetFilters();
        scrollToTop();
    }
}

export default ResetButtonComponent;
